import React, { FC, useCallback } from 'react';
import styles from './index.module.scss';
import { FilterSearch, FilterSort, FilterStatuses } from 'src/shared';
import { useTranslation } from 'react-i18next';
import { useTendersViewState } from 'src/models/procurements/hooks';
import TendersBoard from '../TendersBoard';
import TendersList from '../TendersList';
import { PageView } from 'src/models/users/Preferences/types';
import OverviewSidebars from '../Sidebars';
import { ApiTendersProvider } from 'src/models/procurements/Tenders/providers';
import { TendersTotal, ViewOptionsDropDown } from 'src/shared';
import { PageHeading } from 'src/common';

export const TendersStarred: FC = () => {
  const { t } = useTranslation();
  const [tendersView, setTendersView] = useTendersViewState();

  const toggleView = useCallback(
    (view: PageView) => {
      setTendersView(view);
    },
    [setTendersView]
  );

  return (
    <ApiTendersProvider type={'Starred'}>
      <PageHeading title={t('Tenders.starredTenders')} />
      <div className={styles.heading}>
        <div className={styles.search}>
          <FilterSearch />
          <TendersTotal className={styles.total} />
        </div>

        <div className={styles.headingActions}>
          <FilterStatuses />
        </div>
        {tendersView === PageView.board && (
          <div className={styles.headingActions}>
            <FilterSort />
          </div>
        )}
        <div className={styles.headingActions}>
          <ViewOptionsDropDown onToggleView={toggleView} currentView={tendersView} />
        </div>
      </div>
      <div className={styles.content}>
        {tendersView === PageView.board && <TendersBoard />}
        {tendersView === PageView.table && <TendersList />}
      </div>
      <OverviewSidebars />
    </ApiTendersProvider>
  );
};
TendersStarred.displayName = 'TendersStarred';

export default TendersStarred;
